import * as React from 'react';
import { IconButton, styled, Tooltip, tooltipClasses } from '@mui/material';
import { CheckCircle, Info } from 'react-feather';

// Personalizando el Tooltip
const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

// Personalizando IconButton para eliminar el sombreado al hacer hover
const StyledIconButton = styled(IconButton)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'transparent'  // Elimina el fondo al hacer hover
    },
    '&:focus': {
        backgroundColor: 'transparent'  // Elimina el fondo al estar enfocado
    }
}));

const TooltipAprobacion = ({ tag_id, class_icon, text_span, idregistro, aprobacion_usuario, aprobacion_fecha }) => {
    return (
        <div>
            <HtmlTooltip
                title={
                    <>
                        <b>Usuario Aprobó:</b> {aprobacion_usuario}
                        <br></br>
                        <b>Fecha Aprobación:</b> {aprobacion_fecha}
                    </>
                }
                placement="right"
                arrow
            >
                <StyledIconButton aria-label="info">
                    {/* <span id={tag_id + idregistro} style={{ fontSize: '0.875rem' }}>
                        <i className={class_icon}></i> {text_span}
                    </span> */}
                    <span id={tag_id + idregistro} style={{ display: 'flex', alignItems: 'center', width:'100%',  justifyContent: 'center',  fontSize: '0.8rem' }}>
                        <i className={class_icon} ></i> 
                        <span style={{marginLeft: 3}}>{text_span}</span>
                        {/* {text_span} */}
                    </span>
                </StyledIconButton>
            </HtmlTooltip>
        </div>
    );
};

export default TooltipAprobacion;
